import React from 'react';
import classnames from 'classnames';
import { FormattedMessage } from 'react-intl';
import { useDispatch } from 'react-redux';

import { useAsyncSafeState } from 'ui-components/hooks/async-safe';

import getShipsuranceBalance from './api';
import InsuranceProviderList from './insurance-provider-list';
import { useOnComponentMount } from '../../../../hooks/use-on-component-mount';
import { LogService } from '../../../../services/log-service';
import { updateShipsuranceBalance } from '../../../../store/seller/seller.actions';
import { SettingsPageTitle } from '../../components/settings-page-title/settings-page-title';
import commonStyles from '../../settings-page.module.less';

const LegacyInsuranceSettings = () => {
  const dispatch = useDispatch();
  const [isLoading, setIsloading] = useAsyncSafeState(true);
  useOnComponentMount(() => {
    (async () => {
      try {
        const shipsuranceBalance = await getShipsuranceBalance();
        dispatch(updateShipsuranceBalance(shipsuranceBalance?.value));
      } catch (error) {
        LogService.logError(new Error('Could not request newest shipsurance balance', { cause: error }));
      }
      setIsloading(false);
    })();
  });

  return (
    <div className={classnames(commonStyles['limited-width-page'], commonStyles.content)}>
      <SettingsPageTitle value={<FormattedMessage defaultMessage='Insurance' description='Insurance page title' id='L7heLj' />} />
      <p>
        <FormattedMessage
          defaultMessage='Insurance providers for your shipping needs'
          description='Insurance Page Description'
          id='ufL9z8'
        />
      </p>
      <InsuranceProviderList isLoading={isLoading} />
    </div>
  );
};

export default LegacyInsuranceSettings;
